import React, { ReactElement } from 'react';

const PasskeyIcon1 = (): ReactElement<SVGElement> => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        data-testid="passkey-icon-1"
    >
        <path
            d="M4 26.6667V22.9334C4 22.1778 4.19444 21.4834 4.58333 20.85C4.97222 20.2167 5.48889 19.7334 6.13333 19.4C7.51111 18.7112 8.91111 18.1945 10.3333 17.85C11.7556 17.5056 13.2 17.3334 14.6667 17.3334C15.1111 17.3334 15.5556 17.35 16 17.3834C16.4444 17.4167 16.8889 17.4667 17.3333 17.5334C17.2444 18.8223 17.4778 20.0389 18.0333 21.1834C18.5889 22.3278 19.4 23.2667 20.4667 24V26.6667H4ZM25.3333 30.6667L23.3333 28.6667V22.4667C22.3556 22.1778 21.5556 21.6278 20.9333 20.8167C20.3111 20.0056 20 19.0667 20 18C20 16.7112 20.4556 15.6112 21.3667 14.7C22.2778 13.7889 23.3778 13.3334 24.6667 13.3334C25.9556 13.3334 27.0556 13.7889 27.9667 14.7C28.8778 15.6112 29.3333 16.7112 29.3333 18C29.3333 19 29.05 19.8889 28.4833 20.6667C27.9167 21.4445 27.2 22 26.3333 22.3334L28 24L26 26L28 28L25.3333 30.6667ZM14.6667 16C13.2 16 11.9444 15.4778 10.9 14.4334C9.85556 13.3889 9.33333 12.1334 9.33333 10.6667C9.33333 9.20004 9.85556 7.94449 10.9 6.90004C11.9444 5.8556 13.2 5.33337 14.6667 5.33337C16.1333 5.33337 17.3889 5.8556 18.4333 6.90004C19.4778 7.94449 20 9.20004 20 10.6667C20 12.1334 19.4778 13.3889 18.4333 14.4334C17.3889 15.4778 16.1333 16 14.6667 16ZM24.6667 18.6667C25.0444 18.6667 25.3611 18.5389 25.6167 18.2834C25.8722 18.0278 26 17.7112 26 17.3334C26 16.9556 25.8722 16.6389 25.6167 16.3834C25.3611 16.1278 25.0444 16 24.6667 16C24.2889 16 23.9722 16.1278 23.7167 16.3834C23.4611 16.6389 23.3333 16.9556 23.3333 17.3334C23.3333 17.7112 23.4611 18.0278 23.7167 18.2834C23.9722 18.5389 24.2889 18.6667 24.6667 18.6667Z"
            fill="#1A1A1A"
        />
    </svg>
);

const PasskeyIcon2 = (): ReactElement<SVGElement> => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        data-testid="passkey-icon-2"
    >
        <g clipPath="url(#clip0_1_5244)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.8 9.60005V14.4H24V27.2H8V14.4H11.2V9.60005C11.2 6.96005 13.36 4.80005 16 4.80005C18.64 4.80005 20.8 6.96005 20.8 9.60005ZM16 6.40005C14.24 6.40005 12.8 7.84005 12.8 9.60005V14.4H19.2V9.60005C19.2 7.84005 17.76 6.40005 16 6.40005Z"
                fill="black"
            />
        </g>
        <defs>
            <clipPath id="clip0_1_5244">
                <rect width="32" height="32" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

const PasskeyIcon3 = (): ReactElement<SVGElement> => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        data-testid="passkey-icon-3"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.6 16C25.6 10.72 21.28 6.40002 16 6.40002C10.72 6.40002 6.40002 10.72 6.40002 16C6.40002 21.28 10.72 25.6 16 25.6C21.28 25.6 25.6 21.28 25.6 16ZM19.44 18.32C19.76 18.64 19.76 19.12 19.44 19.44C19.12 19.76 18.64 19.76 18.32 19.44L15.68 16.8C15.36 16.48 15.2 16.08 15.2 15.68V8.80002C15.2 8.32002 15.52 8.00002 16 8.00002C16.48 8.00002 16.8 8.32002 16.8 8.80002V15.68L19.44 18.32Z"
            fill="#1A1918"
        />
    </svg>
);

interface PasskeyIconProps {
    iconType?: 1 | 2 | 3;
}

const PasskeyIcon = ({ iconType = 1 }: PasskeyIconProps) => {
    let iconChoice: ReactElement<SVGElement>;

    if (iconType === 1) {
        iconChoice = PasskeyIcon1();
    } else if (iconType === 2) {
        iconChoice = PasskeyIcon2();
    } else if (iconType === 3) {
        iconChoice = PasskeyIcon3();
    }

    return <div className="passkeys-icon-container">{iconChoice}</div>;
};

export default PasskeyIcon;
